"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinPage = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _JoinComponent = require("../JoinComponent.styled");
var _constants = require("../../../constants");
var _PageNotification = require("../PageNotification/PageNotification");
var _PageTitle = require("../PageTitle/PageTitle");
var _PageBodyTop = require("../PageBodyTop/PageBodyTop");
var _PageFooter = require("../PageFooter/PageFooter");
var _constants2 = require("@studio/constants");
var _GenericCameraPreview = require("../GenericCameraPreview/GenericCameraPreview");
var _PageBody = require("../PageBody/PageBody");
var _MicrophoneSelector = require("../PageBody/MicrophoneSelector");
var _CheckAudioOutput = require("../PageBody/CheckAudioOutput");
var _CameraSelectorSwitch = require("../PageBody/CameraSelectorSwitch");
var _utils = require("../utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _feature = require("@studio/feature.flags");
var _excluded = ["retryTest", "readinessCheck", "user", "userRole", "initializeBackgroundFilter", "joinMeeting", "getVideoInput", "clearVirtualBackground", "CameraPreviewElement", "sourceLoadStatus", "isJoinInProgress"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * JoinPage component for setting up user media devices and preferences before joining a meeting.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Function} props.retryTest - Function to retry media device tests
 * @param {Object} props.readinessCheck - Object containing the status of device readiness checks
 * @param {Object} props.user - User information object
 * @param {Function} props.initializeBackgroundFilter - Function to initialize background blur filter
 * @param {Function} props.joinMeeting - Function to join the meeting with user configuration
 * @param {Function} props.getVideoInput - Function to get video input
 * @param {Function} props.clearVirtualBackground - Function to clear background filter
 * @param {string} props.sourceLoadStatus - Status of source loading
 * @param {boolean} props.isJoinInProgress - Flag indicating if join process is in progress
 * @param {React.Component} [props.CameraPreviewElement=GenericCameraPreview] - Component to use for camera preview
 * @param {Object} props.additionalProps - Additional props to pass to child components
 * @returns {React.Element} Rendered component
 */
var JoinPage = exports.JoinPage = function JoinPage(_ref) {
  var _user$description;
  var retryTest = _ref.retryTest,
    readinessCheck = _ref.readinessCheck,
    user = _ref.user,
    userRole = _ref.userRole,
    initializeBackgroundFilter = _ref.initializeBackgroundFilter,
    joinMeeting = _ref.joinMeeting,
    getVideoInput = _ref.getVideoInput,
    clearVirtualBackground = _ref.clearVirtualBackground,
    _ref$CameraPreviewEle = _ref.CameraPreviewElement,
    CameraPreviewElement = _ref$CameraPreviewEle === void 0 ? _GenericCameraPreview.GenericCameraPreview : _ref$CameraPreviewEle,
    sourceLoadStatus = _ref.sourceLoadStatus,
    _ref$isJoinInProgress = _ref.isJoinInProgress,
    isJoinInProgress = _ref$isJoinInProgress === void 0 ? false : _ref$isJoinInProgress,
    additionalProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedVideoInput = _useState2[0],
    setSelectedVideoInput = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    selectedAudioInput = _useState4[0],
    setSelectedAudioInput = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectedAudioOutput = _useState6[0],
    setSelectedAudioOutput = _useState6[1];
  var _useState7 = (0, _react.useState)(_constants2.BACKGROUND_OPTIONS.NONE),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    userBackground = _useState8[0],
    setUserBackground = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    transformedVideoInput = _useState10[0],
    setTransformedVideoInput = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    userBackgroundLoading = _useState12[0],
    setUserBackgroundLoading = _useState12[1];
  var shouldRequireAudio = (0, _feature.shouldHaveFeature)('studio.requireAudio');
  var _useState13 = (0, _react.useState)("".concat((user === null || user === void 0 ? void 0 : user.firstName) || '', " ").concat((user === null || user === void 0 ? void 0 : user.lastName) || '')),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    presenterTitle = _useState14[0],
    setPresenterTitle = _useState14[1];
  var _useState15 = (0, _react.useState)((_user$description = user === null || user === void 0 ? void 0 : user.description) !== null && _user$description !== void 0 ? _user$description : ''),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    presenterDescription = _useState16[0],
    setPresenterDescription = _useState16[1];
  var _useJoinComponentStat = (0, _hooks.useJoinComponentStates)({
      shouldRequireAudio: shouldRequireAudio,
      readinessCheck: readinessCheck,
      userRole: userRole,
      isStandaloneChecker: false,
      shouldJoinWithoutKnock: false
    }),
    checkStatus = _useJoinComponentStat.checkStatus,
    currentPage = _useJoinComponentStat.currentPage,
    errors = _useJoinComponentStat.errors,
    warnings = _useJoinComponentStat.warnings,
    notification = _useJoinComponentStat.notification,
    setCurrentPage = _useJoinComponentStat.setCurrentPage;
  var noErrorOrWarning = errors.length === 0 && warnings.length === 0;
  var _useGetMediaDevices = (0, _hooks.useGetMediaDevices)({
      video: true
    }),
    videoInputDevices = _useGetMediaDevices.videoInputDevices;
  var _useGetMediaDevices2 = (0, _hooks.useGetMediaDevices)({
      audio: true
    }),
    audioInputDevices = _useGetMediaDevices2.audioInputDevices,
    audioOutputDevices = _useGetMediaDevices2.audioOutputDevices;
  (0, _react.useEffect)(function () {
    if (selectedVideoInput === null && videoInputDevices.length > 0) {
      var _videoInputDevices$;
      var selectedDeviceId = (_videoInputDevices$ = videoInputDevices[0]) === null || _videoInputDevices$ === void 0 ? void 0 : _videoInputDevices$.value;
      if (selectedDeviceId) {
        setSelectedVideoInput(selectedDeviceId);
      }
    }
  }, [videoInputDevices, selectedVideoInput]);
  (0, _react.useEffect)(function () {
    if (selectedAudioInput === null && audioInputDevices.length > 0) {
      var _audioInputDevices$;
      var selectedAudioDeviceId = (_audioInputDevices$ = audioInputDevices[0]) === null || _audioInputDevices$ === void 0 ? void 0 : _audioInputDevices$.value;
      if (selectedAudioDeviceId) {
        setSelectedAudioInput(selectedAudioDeviceId);
      }
    }
  }, [audioInputDevices, selectedAudioInput]);
  (0, _react.useEffect)(function () {
    if (selectedAudioOutput === null && audioOutputDevices.length > 0) {
      var _audioOutputDevices$;
      var selectedAudioOutputId = (_audioOutputDevices$ = audioOutputDevices[0]) === null || _audioOutputDevices$ === void 0 ? void 0 : _audioOutputDevices$.value;
      if (selectedAudioOutputId) {
        setSelectedAudioOutput(selectedAudioOutputId);
      }
    }
  }, [audioOutputDevices, selectedAudioOutput]);
  var join = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var transformedVideoInputs, allData;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _utils.handleTransformedVideoInput)(userBackground, transformedVideoInput, setTransformedVideoInput, clearVirtualBackground);
          case 2:
            transformedVideoInputs = _context.sent;
            allData = {
              presenterTitle: presenterTitle,
              presenterDescription: presenterDescription,
              selectedVideoInput: selectedVideoInput,
              selectedAudioInput: selectedAudioInput,
              userBackground: userBackground,
              transformedVideoInputs: transformedVideoInputs
            };
            console.log('Joining with data:', allData);
            joinMeeting(allData);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function join() {
      return _ref2.apply(this, arguments);
    };
  }();
  var updateUserBackground = function updateUserBackground(backgroundOption) {
    return (0, _utils.handleUpdateUserBackground)(setUserBackgroundLoading, transformedVideoInput, selectedVideoInput, setUserBackground, setSelectedVideoInput, setTransformedVideoInput, backgroundOption, getVideoInput);
  };
  var updatedVideoInput = function updatedVideoInput(videoInputDevice) {
    return (0, _utils.handleUpdateVideoInput)(setUserBackgroundLoading, userBackground, transformedVideoInput, setSelectedVideoInput, setTransformedVideoInput, videoInputDevice, getVideoInput);
  };
  var disableInput = readinessCheck.microphone === _constants.PERMISSION_DENIED;
  var disableVideoInput = (videoInputDevices === null || videoInputDevices === void 0 ? void 0 : videoInputDevices.length) === 1 && videoInputDevices[0].value === '' || userBackgroundLoading || disableInput;
  var hasAudioDevice = audioInputDevices.length > 0;
  var hasTitle = presenterTitle.trim().length > 0;
  var _getUserNameFromPrese = (0, _utils.getUserNameFromPresenterTitle)(presenterTitle),
    firstName = _getUserNameFromPrese.firstName,
    lastName = _getUserNameFromPrese.lastName;
  var hasFirstNameExceededLimit = firstName.trim().length > 30;
  var hasLastNameExceededLimit = lastName.trim().length > 50;
  var hasDescriptionExceededLimit = presenterDescription.trim().length > 80;
  var hasValidationError = !hasTitle || hasFirstNameExceededLimit || hasLastNameExceededLimit || hasDescriptionExceededLimit;
  return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledGenericCard, {
    className: "shadow-sm",
    "data-testid": "join-page"
  }, /*#__PURE__*/_react["default"].createElement(_PageNotification.PageNotification, {
    key: notification.id,
    noErrorOrWarning: noErrorOrWarning,
    notification: notification
  }), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardBody, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitleContainer, null, /*#__PURE__*/_react["default"].createElement(_PageTitle.PageTitle, {
    page: currentPage
  })), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSettingsComponentContent, null, /*#__PURE__*/_react["default"].createElement(_PageBodyTop.PageBodyTop, {
    currentPage: currentPage,
    checkStatus: checkStatus,
    errors: errors,
    warnings: warnings
  }), /*#__PURE__*/_react["default"].createElement(_PageBody.PageBody, {
    presenterTitle: presenterTitle,
    presenterDescription: presenterDescription,
    checkStatus: checkStatus,
    setPresenterTitle: setPresenterTitle,
    setPresenterDescription: setPresenterDescription,
    readinessCheck: readinessCheck,
    microphoneSelector: /*#__PURE__*/_react["default"].createElement(_MicrophoneSelector.MicrophoneSelector, {
      selectedAudioInputDevice: selectedAudioInput,
      audioInputDevices: audioInputDevices,
      onMicrophoneChange: setSelectedAudioInput,
      disabled: disableInput
    }),
    checkAudioOutput: /*#__PURE__*/_react["default"].createElement(_CheckAudioOutput.CheckAudioOutput, {
      audioOutputDevice: selectedAudioOutput,
      disabled: disableInput
    }),
    cameraSelector: /*#__PURE__*/_react["default"].createElement(_CameraSelectorSwitch.CameraSelectorSwitch, {
      selectedVideoInput: selectedVideoInput,
      videoInputDevices: videoInputDevices,
      onCameraChange: updatedVideoInput,
      disabled: disableVideoInput,
      userBackground: userBackground,
      setUserBackground: updateUserBackground,
      initializeBackgroundFilter: initializeBackgroundFilter
    }),
    cameraPreview: /*#__PURE__*/_react["default"].createElement(CameraPreviewElement, (0, _extends2["default"])({
      videoInputDevice: selectedVideoInput,
      presenterTitle: presenterTitle,
      presenterDescription: presenterDescription,
      checkStatus: checkStatus
    }, additionalProps)),
    currentPage: currentPage
  })), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardFooter, null, /*#__PURE__*/_react["default"].createElement(_PageFooter.PageFooter, {
    currentPage: currentPage,
    checkStatus: checkStatus,
    errors: errors,
    hasValidationError: hasValidationError,
    hasAudioDevice: hasAudioDevice,
    isStandaloneChecker: false,
    sourceLoadStatus: sourceLoadStatus,
    goToPage: setCurrentPage,
    runSystemCheck: retryTest,
    handleJoinMeeting: join,
    isJoinInProgress: isJoinInProgress
  }))));
};
JoinPage.propTypes = {
  retryTest: _propTypes["default"].func.isRequired,
  readinessCheck: _propTypes["default"].object.isRequired,
  user: _propTypes["default"].object.isRequired,
  userRole: _propTypes["default"].string,
  initializeBackgroundFilter: _propTypes["default"].func.isRequired,
  joinMeeting: _propTypes["default"].func.isRequired,
  getVideoInput: _propTypes["default"].func.isRequired,
  clearVirtualBackground: _propTypes["default"].func.isRequired,
  CameraPreviewElement: _propTypes["default"].elementType,
  sourceLoadStatus: _propTypes["default"].string,
  isJoinInProgress: _propTypes["default"].bool,
  additionalProps: _propTypes["default"].object
};